<!--
 - Author : whl.
 - Date   : 2019/12/10.
 - File   : floor.楼层切换组件
 -->

<template>
  <div class="floor-content" v-if="floorList.length > 0">
    <div :class="['floor-content-top', topAble?'':'no-click']" @click="floorTop">
      <img src="../../assets/images/shitang/floorTop.png" alt="">
    </div>
    <div class="floor-content-middle" :style="{maxHeight: changeHeight+'px', height:floorList.length*31+'px'}">
      <ul ref="floorUl" :style="{top: topHieght+'px'}">
        <li :class="selectFloor===index?'on': ''"
            v-for="(item, index) in floorList"
            :key="index"
            @click="chooseFloor(index, item)">
          {{item.floorName}}</li>
      </ul>
    </div>
    <div :class="['floor-content-down', downAble?'':'no-click']" @click="floorDown">
      <img src="../../assets/images/shitang/floorDown.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'floor',
    data () {
      return {
        selectFloor: 0,
        topAble: true,
        downAble: false,
        topHieght: 0,
        changeHeight: 0
      }
    },
    props: {
      floorList: {},
      num: {}
    },
    watch: {
      floorList() {
        this.topAble = this.floorList.length > this.num
        this.changeHeight = this.num * 31
      }
    },
    methods: {
      /**
       * @Description:切换楼层
       * @author wanghongling
       * @param item
       * @param index 选中的楼层序号
       * @createDate 2019/12/9
       */
      chooseFloor(index, item) {
        this.selectFloor = index
        this.$emit('chooseEvent', item)
      },
      /**
       * @Description:点击top按钮
       * @author wanghongling
       * @createDate 2019/12/9
       */
      floorTop() {
        let tmp = this.$refs.floorUl.style.top
        let ulHeight = this.$refs.floorUl.clientHeight
        let reg = /px/g
        let nowHeight = Math.abs(parseFloat(tmp.replace(reg, '')))
        this.downAble = true
        this.topHieght = -(this.changeHeight + nowHeight)
        if ((ulHeight - Math.abs(this.topHieght)) <= this.changeHeight) {
          this.topAble = false
        }
      },
      /**
       * @Description:点击down按钮
       * @author wanghongling
       * @createDate 2019/12/9
       */
      floorDown() {
        let tmp = this.$refs.floorUl.style.top
        let reg = /px/g
        let nowHeight = Math.abs(parseFloat(tmp.replace(reg, '')))
        this.topAble = true
        this.topHieght = -(nowHeight - this.changeHeight)
        if (this.topHieght === 0) {
          this.downAble = false
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .floor-content{
    width: 65px;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    z-index: 9;
    .no-click{
      cursor: not-allowed;
      pointer-events:none;
      opacity: 0.4;
    }
    &-top, &-down{
      cursor: pointer;
      z-index: 2;
      >img {
        width: 100%;
        vertical-align: sub;
      }
    }
    &-middle{
      position: relative;
      z-index: 1;
      min-height: 31px;
      overflow: hidden;
      text-align: center;
      background-color: #052238;
      >ul{
        position: absolute;
        top: 0;
        width: 65px;
        color: #09829f;
        font-size: 14px;
        transition: all .3s;
        >li{
          background-color: #053456;
          border-top: 1px solid #000306;
          line-height: 30px;
          cursor: pointer;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        >li.on{
          color: #fff;
          background-color: #00698c;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/floor.vue